export const LOGO_BACKGROUND_RGB = "rgba(205, 240, 255)";
export const MOBILE_VIEW_MAX_WIDTH_EM = "48em";
